import * as XLSX from "xlsx";

type ExcelLifecycle = {
  onStart?: () => void;
  onFinish?: () => void;
};

function getTimestamp(): string {
  const now = new Date();

  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, "0");
  const dd = String(now.getDate()).padStart(2, "0");

  const hh = String(now.getHours()).padStart(2, "0");
  const min = String(now.getMinutes()).padStart(2, "0");

  return `${yyyy}${mm}${dd}-${hh}${min}`;
}

export class ToolExcel {

  async generateFile<T extends object>(
    data: T[],
    baseFileName: string,
    sheetName: string,
    lifecycle?: ExcelLifecycle
  ): Promise<void> {

    lifecycle?.onStart?.();

    try {
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const fileName = `${getTimestamp()}-${baseFileName}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } finally {
      lifecycle?.onFinish?.();
    }
  }

  async generateTemplate(
    columns: string[],
    baseFileName: string,
    sheetName: string,
    lifecycle?: ExcelLifecycle
  ): Promise<void> {

    lifecycle?.onStart?.();

    try {
      const worksheet = XLSX.utils.aoa_to_sheet([columns]);
      const workbook = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      const fileName = `${getTimestamp()}-${baseFileName}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } finally {
      lifecycle?.onFinish?.();
    }
  }
}